import { Singleton } from "../Singleton";
import { AttentionOffice } from "./quickTurnServices/AttentionOffice";
import { AttentionPointAgenda } from "./quickTurnServices/AttentionPointAgenda";
import { AttentionService } from "./quickTurnServices/AttentionService";
import { AttentionTicket } from "./quickTurnServices/AttentionTicket";
import { CustomerType } from "./quickTurnServices/CustomerType";
import { QuickturnAppointment } from "./quickTurnServices/QuickturnAppointment";

export const _single = Singleton.getInstance();

export const _QuickCustomerType = new CustomerType("QuickTurn", "com.quickturn.bean.CustomerType");
export const _AttentionOffice = new AttentionOffice("QuickTurn", "com.quickturn.bean.AttentionOffice");
export const _AttentionPoint = new AttentionOffice("QuickTurn", "com.quickturn.bean.AttentionPoint");
export const _AttentionPointAgenda = new AttentionPointAgenda("QuickTurn", "com.quickturn.bean.AttentionPointAgenda");
export const _AttentionService = new AttentionService("QuickTurn", "com.quickturn.bean.AttentionService");
export const _QuickturnAppointment = new QuickturnAppointment("QuickTurn", "com.quickturn.bean.Appointment");
export const _AttentionTicket = new AttentionTicket("QuickTurn", "com.quickturn.bean.AttentionTicket");